import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const dashboardAnalyticsSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.ANALYTICS_VIEW_MODE}`,
        popover: {
            title: "View Mode",
            description:
                "Switch how the data is aggregated. <strong>Average</strong> normalizes scores per game played, " +
                "<strong>Total</strong> sums all raw points across your selected matches, " +
                "<strong>Line</strong> groups players by their assigned line so you can compare unit performance side-by-side, and " +
                "<strong>Period</strong> breaks down each player's KPIs per game period with a side-by-side team comparison.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.ANALYTICS_EXPORT}`,
        popover: {
            title: "Export to Excel",
            description:
                "Download the currently displayed analytics data as an Excel file. " +
                "The export reflects your active view mode and selected matches — perfect for sharing with coaching staff or archiving performance reports.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.ANALYTICS_DATA_AREA}`,
        popover: {
            title: "Performance Data",
            description:
                "This area displays your squad's statistics based on the active view mode. " +
                "In <strong>Average</strong> and <strong>Total</strong> mode you'll see separate goalkeeper and skater tables with KPI breakdowns across Defensive, Offensive, Team Play, Effort, and Bonus categories — column highlights mark the top three values in each category. " +
                "In <strong>Line</strong> mode players are grouped by line for unit-level comparison. " +
                "In <strong>Period</strong> mode per-period KPIs are shown side-by-side for both teams, with an option to merge them into a single combined table.",
            side: "top",
            align: "center",
        },
    },
];
